import React, { ComponentProps } from 'react';

import { ActivityCard } from '@adsk/alloy-react-activity-log';
import theme from '@adsk/alloy-react-theme';

const PlanTaskEntityActivityCardFooter = (
  props: ComponentProps<typeof ActivityCard.Footer>,
) => (
  <ActivityCard.Footer
    {...props}
    style={[
      theme.typography.caption,
      {
        marginTop: 12,
        color: theme.colors.charcoal500,
      },
    ]}
  />
);

export default PlanTaskEntityActivityCardFooter;
